<template>
    <transition>
        <div class="chat-dialog-container" v-if="showDialog">
            <div class="chat-background" @click="showDialog = false"></div>
            <div class="chat-dialog">
                <div style="display: flex; justify-content: flex-end; padding: 10px;">
                    <img src="../assets/close.svg" @click="showDialog = false" style="cursor: pointer; width: 38px;" />
                </div>
                <div style="display: flex; justify-content: center;">
                    <div style="width: 70%; text-align: left; font-weight: 600;  font-size: 1.5em">Detailed Report</div>
                </div>
                <div>
                    <div id="detailed-report-output" v-html="text" style="overflow: auto; margin: 0 5rem; text-align: left; height: 700px; overflow: auto; box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; padding: 1rem; margin-top: 1rem;"></div>
                </div>

            </div>

        </div>
    </transition>
</template>

<script setup>
import { useAuth0 } from '@auth0/auth0-vue';
import axios from 'axios';
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'

const { user } = useAuth0()

const store = useStore()

const showDialog = computed({
    get: () => store.getters.showDetailedReportDialog,
    set: (value) => store.commit('SET_SHOW_DETAILED_REPORT_DIALOG', value)
})

const text = ref(null) 
const loading = ref("")


watch(showDialog, async (value) => {
    if (value === true) {
        try {
            text.value = "<p class='blink_me'>Loading ...</p>"
            const currentInput = store.getters.currentInput

            const response = await axios.post(`${process.env.VUE_APP_BACKEND_URI}/detailed-report`, { text: currentInput, email: user.value.email })
            
            text.value  = ""

            const speed = 20
            let lastChar = ""
            for (let i = 0; i < response.data.answer.length; i++) {
                setTimeout(() => {
                    const char = response.data.answer.charAt(i)
                    if (char == "\n")
                        text.value  += "<br/>"
                    else if (char == "-" && /\s/.test(lastChar))
                        text.value  += "&#8226; "
                    else if (char == "•" && /\s/.test(lastChar))
                        text.value  += "&#8226; "
                    else
                        text.value  += response.data.answer.charAt(i)

                    lastChar = char

                }, i * speed)
            }


        } catch (error) {
            console.log(error)
        }
    }
})


</script>

<style lang="scss" scoped>
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.3s ease-in-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

.chat-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.445);
    cursor: pointer;
}

.chat-dialog-container {
    position: fixed;
    top: 0;
    height: 0;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.blink_me {
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
        opacity: 0;
    }
}

.chat-dialog {
    background: white;
    width: 80%;
    min-height: 900px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.445);
    z-index: 15;



}

.send-button-chat {
    margin-top: 1rem;
    padding: 10px;
    border: none;
    border-radius: 5px;
    background: #2d2d2d;
    color: white;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background: #3d3d3d;
    }

    &:active {
        background: #1d1d1d;
    }
}
</style>